'use client'

import { Loading01Icon } from '@repo/studio-design-system-ui-icons/general/loading-01'
import { AnimatePresence, m } from 'framer-motion'
import { tw } from 'utils/classnames'

type LoadingSpinnerSize = 'md' | 'sm' | 'xs'

export function LoadingSpinner({ loading, size }: { loading?: boolean; size: LoadingSpinnerSize }) {
  return <AnimatePresence>{loading ? <Spinner size={size} /> : null}</AnimatePresence>
}

const loadingSpinnerClasses = {
  sizes: {
    md: ['size-4'].join(' '),
    sm: ['size-3'].join(' '),
    xs: ['size-2'].join(' '),
  },
}

export function Spinner({ size }: { size: LoadingSpinnerSize }) {
  const loaderSpinnerClassName = tw('animate-spin', loadingSpinnerClasses.sizes[size])

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      // Portalled into the button, so a click it swallows never reaches the button's own handler.
      className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-2 bg-gray-700 text-gray-400 outline-none"
    >
      <Loading01Icon className={loaderSpinnerClassName} />
    </m.div>
  )
}
